import { create } from 'zustand';

type Screen =
  | 'login'
  | 'register'
  | 'dashboard'
  | 'forms'
  | 'hse-weekly'
  | 'jha'
  | 'civil-inspection'
  | 'shop-inspection'
  | 'building-inspection'
  | 'toolbox-meeting'
  | 'approvals'
  | 'reports'
  | 'settings';

interface UiState {
  currentScreen: Screen;
  notifications: number;
  pendingApprovals: number;
  isSidebarOpen: boolean;

  // Actions
  setCurrentScreen: (screen: Screen) => void;
  setNotifications: (count: number) => void;
  setPendingApprovals: (count: number) => void;
  toggleSidebar: () => void;
  incrementNotifications: () => void;
  decrementNotifications: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  currentScreen: 'login',
  notifications: 0,
  pendingApprovals: 0,
  isSidebarOpen: false,

  setCurrentScreen: (screen) => set({ currentScreen: screen }),

  setNotifications: (count) => set({ notifications: count }),

  setPendingApprovals: (count) => set({ pendingApprovals: count }),

  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),

  incrementNotifications: () => set((state) => ({
    notifications: state.notifications + 1
  })),

  decrementNotifications: () => set((state) => ({
    notifications: Math.max(0, state.notifications - 1)
  })),
}));
